import { TagSchema } from "@redotech/redo-common-model-tags-common/tag";
import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  CreateFulfillmentOrderSchema,
  type ICreateFulfillmentOrder,
} from "@redotech/redo-fulfillment-operations-common/create-fulfillment-order";
import * as z from "zod";

export const createManualFulfillmentGroups = {
  name: "createManualFulfillmentGroups" as const,
  description:
    "Create manual orders (fulfillment groups) that are not tied to a marketplace order. Also the right tool when the merchant received a purchase order (PO) from a wholesale/retail buyer and is acting as the supplier fulfilling it: that is an outbound manual order (use the buyer's PO number as the orderNumber and their ship-to address), NOT a Redo purchase order — createPurchaseOrder is only for POs the merchant issues to their own suppliers to receive inventory. Each fulfillment order needs a ship-to address, order info (order number, dates, totals), and line items with titles, quantities, prices, and weights. Never invent titles, SKUs, or prices.",
  mutates: true,
  input: z.object({
    fulfillmentOrders: z.array(
      CreateFulfillmentOrderSchema as ICreateFulfillmentOrder,
    ),
    shipmentTags: z.array(TagSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema).nullish(),
  }),
};
